import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link, useNavigate } from "react-router-dom"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Col, Row, Card, CardBody, Label } from "reactstrap"

// import { ToastContainer } from "react-toastify"
import {
  getReports as onGetReports,
  getReportTypes as onGetReportTypes,
} from "store/actions"

// selector
import Select from "react-select"

//redux
import { useSelector, useDispatch } from "react-redux"
import { isEmpty } from "lodash"
import EmptyContainer from "components/Common/EmptyContainer"

function Report() {
  const dispatch = useDispatch()
  const [reportType, setReportType] = useState("All")
  const [filterData, setFilterData] = useState([])

  useEffect(() => {
    dispatch(onGetReports(""))
    dispatch(onGetReportTypes())
  }, [dispatch])

  const { reports, reporttypes, loading } = useSelector(state => state.report)
  const { basicSetting } = useSelector(state => state.Layout)
  //meta title
  document.title =
    "Reports | " + (basicSetting?.SiteName || process.env.REACT_APP_NAME)
  useEffect(() => {
    setFilterData(reports)
  }, [reports])

  const FilterRecords = obj => {
    setReportType(obj.ReportType)
    if (obj.ReportTypeID > 1) {
      let filter = reports.filter(x => x.ReportTypeID == obj.ReportTypeID)
      setFilterData(filter)
    } else {
      setFilterData(reports)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Reports" />
          <Row hidden={true}>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <form action="#">
                    <Row className="g-3">
                      <Col xxl={2} lg={3}>
                        <Select
                          className="select2"
                          onChange={e => FilterRecords(e)}
                          options={reporttypes}
                          getOptionLabel={option => option.ReportType}
                          getOptionValue={option => option.ReportTypeID}
                        />
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <h4 hidden={true}>{reportType}</h4>
            {isEmpty(filterData) ? (
              <EmptyContainer />
            ) : (
              <>
                {filterData &&
                  (filterData || []).map((item, index) => {
                    return (
                      <Col key={"report" + index} xl={3}>
                        <Card>
                          <CardBody>
                            <h5 className="fs-17 mb-2">
                              <Link
                                to={"/report/" + item.RowID}
                                className="text-dark"
                              >
                                {item.ReportTitle}
                              </Link>
                            </h5>
                            <ul className="list-inline mb-0">
                              <li className="list-inline-item">
                                <p className="text-muted fs-14 mb-1">
                                  {item.Description}
                                </p>
                              </li>
                            </ul>
                            <div className="mt-3 hstack gap-2">
                              <span className="badge rounded-1 badge-soft-success">
                                {item.ReportType}
                              </span>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    )
                  })}
              </>
            )}
          </Row>
        </div>
      </div>
      {/* <ToastContainer /> */}
    </React.Fragment>
  )
}
Report.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Report
